import { useState } from "react";
import { registerForm } from "./functions";


const MainRegister = () => {
  const [name, setName] = useState("")
  const [res, setRes] = useState({})
  const [projectIncludesInfo, setProjectIndcludesInfo] = useState([])
  const [rooms, setRooms] = useState([])
  const [pavements, setPavements] = useState([])
  const [projectHas, setProjectHas] = useState([])
  const [guardrail, setGuardrail] = useState([])
  const [stairs, setStairs] = useState([])
  const [floors, setFloors] = useState([])
  const [baseboards, setBaseboards] = useState([])
  const [ceiling, setCeiling] = useState([])
  const [wallsRevest, setWallsRevest] = useState([])
  const [hidrWalls, setHidrWalls] = useState([])
  const [pools, setPools] = useState([])
  const [privAreas, setPrivAreas] = useState([])

  const handleName = (e) => {
    setName(e.target.value)
  }

  const removeDeleted = (arr) => {

    return arr.filter(i => rooms.includes(i))
  }

  const handleSend = async () => {
    const roomDefinitions = {
      guardrail: removeDeleted(guardrail),
      stairs: removeDeleted(stairs),
      floors: removeDeleted(floors),
      ceiling: removeDeleted(ceiling),
      wallsRevest: removeDeleted(wallsRevest),
      hidrWalls: removeDeleted(hidrWalls),
      pools: removeDeleted(pools),
      privAreas: removeDeleted(privAreas),
      baseboards: removeDeleted(baseboards)
    }
    const response = await registerForm(name, projectIncludesInfo, roomDefinitions, rooms, projectHas, pavements)
    if (response) {
      window.open(`clientForm/${response.id}`, '_blank');
    }
    setRes(response)
  }

  const opts = ["Tipo de Telhado",
    "Estrutura do Telhado",
    "Tipo de Calha",
    "Materiais de Guarda-corpo",
    "Materiais da Escada (Estrutura, piso, teto, corrimão)",
    "Pisos",
    "Material dos Peitoris e Pingadeiras",
    "Soleiras nas Portas",
    "Revestimento das Paredes",
    "Tipo de Rodapé",
    "Tipo de Acabamento de Teto",
    "Pré-Acabamento de Teto",
    "Tipo de Pergolado",
    "Piscina"]

  const roomsFields = [
    { label: "Guarda-corpo", arr: guardrail, str: "guardrail" },
    { label: "Escada", arr: stairs, str: "stairs" },
    { label: "Pisos", arr: floors, str: "floors" },
    { label: "Rodapés", arr: baseboards, str: "baseboard" },
    { label: "Teto", arr: ceiling, str: "ceiling" },
    { label: "Revestimento de paredes não definidos", arr: wallsRevest, str: "wallsRevest" },
    { label: "Paredes Hidráulicas", arr: hidrWalls, str: "hidrWalls" },
    { label: "Piscinas", arr: pools, str: "pools" },
    { label: "Áreas Privativas", arr: privAreas, str: "privAreas" },
  ]

  const handleUpdate = (e) => {
    if (!projectIncludesInfo.includes(e)) {
      setProjectIndcludesInfo([...projectIncludesInfo, e])
    } else {
      setProjectIndcludesInfo(projectIncludesInfo.filter(i => i !== e))
    }
  }

  const handleProjectHas = (e) => {
    if (!projectHas.includes(e)) {
      setProjectHas([...projectHas, e])
    } else {
      setProjectHas(projectHas.filter(i => i !== e))
    }
  }

  const saveRooms = (e) => {
    const text = e.target.value;
    const arr = text.split("\n").map(room => room.trim()).filter(room => room.length > 0);

    setRooms(arr);

    const fillAll = (func) => {
      func(prev => [
        ...prev,
        ...arr.filter(room => !prev.includes(room))
      ]);
    }

    fillAll(setFloors)
    fillAll(setBaseboards);
    fillAll(setCeiling);
    fillAll(setWallsRevest);

  };

  const handlePavements = (e) => {

    const text = e.target.value;
    const arr = text.split("\n").map(room => room.trim()).filter(room => room.length > 0);
    const pav = arr.map(i => {
      return {
        pavement: i,
        rooms: []
      }
    })

    setPavements(pav);
  }

  const handleRooms = (e, type) => {
    let temp
    switch (type) {
      case 'guardrail':
        temp = guardrail
        break;
      case 'stairs':
        temp = stairs
        break;
      case 'floors':
        temp = floors
        break;

      case 'baseboard':
        temp = baseboards
        break;
      case 'hidrWalls':
        temp = hidrWalls
        break;
      case 'pools':
        temp = pools
        break;
      case 'privAreas':
        temp = privAreas
        break;
      case 'ceiling':
        temp = ceiling
        break;
      case 'wallsRevest':
        temp = wallsRevest
        break;
      default:
        break;
    }
    if (!temp.includes(e)) {
      temp = [...temp, e]
    } else {
      temp = temp.filter(i => i !== e)
    }
    switch (type) {
      case 'guardrail':
        setGuardrail(temp)
        break;
      case 'stairs':
        setStairs(temp)
        break;
      case 'floors':
        setFloors(temp)
        break;
      case 'baseboard':
        setBaseboards(temp)
        break;
      case 'hidrWalls':
        setHidrWalls(temp)
        break;
      case 'pools':
        setPools(temp)
        break;
      case 'privAreas':
        setPrivAreas(temp)
        break;
      case 'ceiling':
        setCeiling(temp)
        break;
      case 'wallsRevest':
        setWallsRevest(temp)
        break;
      default:
        break;
    }
  }

  return <div className="cartesian-form">
    <h1>Cadastrar Obra</h1>

    <h2>Nome:</h2>
    <input className="nameInput" value={name} onChange={handleName} type="text" />

    <div className="flex flex-wrap gap-24 margin-bottom-8">
      <div>
        <h2>Ambientes do projeto (um por linha):</h2>
        <textarea onBlur={saveRooms} />
      </div>
      <div>
        <h2>Pavimentos do projeto (um por linha):</h2>
        <textarea onBlur={handlePavements} />
      </div>
    </div>

    <div className="form-section">
      <h2 className='main-header'>Pavimentos</h2>

      <div className='group-questions-container'>
        {pavements.map((i, idx) => {
          return <div className="question-container">
            <label className="group-header margin-tier-1">{i.pavement}</label>
            <div className="project-includes-container margin-left-16">
              {rooms
                .filter(j => !pavements.some((p, pIdx) => pIdx !== idx && p.rooms.includes(j)))
                .map(j => (
                  <div
                    key={j + i.pavement}
                    className={`project-includes-card margin-bottom-16 ${i.rooms.includes(j) ? "selected" : ""}`}
                    onClick={() => {
                      const updatedPavements = [...pavements];
                      if (i.rooms.includes(j)) {
                        updatedPavements[idx].rooms = updatedPavements[idx].rooms.filter(room => room !== j);
                      } else {
                        updatedPavements[idx].rooms.push(j);
                      }
                      setPavements(updatedPavements);
                    }}
                  >
                    <label>{j}</label>
                  </div>
                ))}
            </div>
          </div>
        })}
      </div>
    </div>

    <h2>Selecione as informações que estão COMPLETAS no projeto:</h2>
    <div className="project-includes-container margin-left-16 margin-bottom-24 flex">
      {opts.map(i => {
        return <div key={i} className={`project-includes-card ${projectIncludesInfo.includes(i) ? "selected" : ""}`} onClick={() => handleUpdate(i)}>
          <label>{i}</label>
        </div>
      })}
    </div>

    <h2>O projeto possui:</h2>
    <div className="flex project-includes-container margin-left-16 margin-bottom-24">
      {["Molduras", "Pergolado", "Piscina"].map(i => {
        return <div key={i} className={`project-includes-card ${projectHas.includes(i) ? "selected" : ""}`} onClick={() => handleProjectHas(i)}>
          <label>{i}</label>
        </div>
      })}
    </div>

    {roomsFields.map(({ label, str, arr }) => {
      if (label === "Piscinas" && !projectHas.includes("Piscina")) return
      return <div className="form-section" key={label}>
        <h2 className='main-header'>Ambientes que possuem {label}:</h2>
        <div className="group-questions-container">
          {pavements.map(i => {
            if (i.rooms.length === 0) return null;
            return <div className="question-container project-includes-container margin-left-16 margin-bottom-16">
              <label className="margin-tier-2">{i.pavement}</label>
              {i.rooms.map(j => {
                return <div key={j} className={`project-includes-card ${arr.includes(j) ? "selected" : ""}`} onClick={() => handleRooms(j, str)}>
                  <label>{j}</label>
                </div>
              })}
            </div>

          })}
        </div>
      </div>
    })}

    <button onClick={handleSend} className="button button-accent send-button">Enviar</button>
    <div>
      {res && Object.keys(res).length > 0 && (
        <div>
          <h2>Enviado! Id: {res.id}</h2>
          <a href={`clientForm/${res.id}`} target='_blank'>Clica aqui pra abrir a página desse projeto em nova aba</a>
        </div>
      )}
    </div>
  </div>
}

export default MainRegister;